import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';

export class ProjectMaster {
  ID: number = 0;
  CLIENT_ID: number;
  // ID: number;
  NAME: string;
  DESCRIPTION: string;
  ESTIMATED_MANDAYS: number;
  ICON: string;
  START_DATE: string;
  END_DATE: string;
  ATTACHMENT_1: string;
  ATTACHMENT_2: string;
  ATTACHMENT_3: string;
  STATUS: string = 'A';
  PROJECT_CLIENT_ID: number;
  ESTIMATED_HOURS: number;
  ESTIMATED_MINUTES: number;
  ESTIMATED_SECONDS: number;
  ABBREVATION: string;
  IS_ACTIVE: boolean;
  IS_BILLABLE: boolean;
  IS_GENERATE_REPORT: boolean;
  SEQ_NO: any;
}

@Component({
  selector: 'app-project-master',
  templateUrl: './project-master.component.html',
  styleUrls: ['./project-master.component.css'],
})
export class ProjectDetailsMasterComponent implements OnInit {
  drawerVisible!: boolean;
  drawerTitle!: string;
  isSpinning = false;
  isOk = true;
  drawerData: ProjectMaster = new ProjectMaster();
  public commonFunction: any;
  formTitle = 'Manage Projects';
  dataList: any[] = [];
  loadingRecords = false;
  totalRecords = 1;
  pageIndex = 1;
  pageSize = 10;
  sortValue: string = 'desc';
  sortKey: string = 'id';
  searchText: string = '';
  ResetDataList = [];

  columns: string[][] = [
    ['NAME', 'NAME'],
    ['SEQ_NO', 'SEQ_NO'],
    ['IS_ACTIVE', 'Active'],
  ];

  drawerClose2!: Function;

  constructor(
    private api: ApiService,
    private message: NzNotificationService,
    public cookie: CookieService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {}

  filterQuery: any;
  SeqDataList = [];
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
      this.sortKey = 'SEQ_NO';
      this.sortValue = 'asc';
    }
    this.loadingRecords = true;
    let sort: string = this.sortValue.startsWith('a') ? 'asc' : 'desc';
    let likeQuery = '';
    if (this.searchText) {
      likeQuery = ' AND(';
      this.columns.forEach((column) => {
        likeQuery += ` ${column[0]} like '%${this.searchText}%' OR`;
      });
      likeQuery = likeQuery.slice(0, -2) + ')';
    }

    this.api.getAllProjects(0, 0,   // 'SEQ_NO',
      this.sortKey, sort , likeQuery).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.totalRecords = data['count'];
          this.dataList = data['data'];
          this.SeqDataList = data['data'];
          this.ResetDataList = data['data'];
        } else {
          this.message.error('Something Went Wrong', '');
          this.dataList = [];
          this.SeqDataList = [];
          this.ResetDataList = [];
        }
        this.loadingRecords = false;
      },
      (err) => {
        console.error(err); // Log the error for debugging
        this.message.error('Error fetching data', '');
        this.loadingRecords = false;
      }
    );
  }

  keyup(event: any) {
    if (event.length > 3) {
      let mysearch = event.toLowerCase();

      let newarrayList = this.dataList.filter(
        (data) =>
          data.NAME.toLowerCase().includes(mysearch) ||
          data.SEQ_NO.toString().toLowerCase().includes(mysearch) // Ensuring SEQ_NO is a string
      );

      // Update dataList with the filtered results
      this.dataList = [...newarrayList];
    } else if (event === null || event === '') {
      // Reset dataList when the search input is cleared
      this.dataList = [...this.SeqDataList];
    }
  }

  updateprojectrecords: boolean = false;
  projectData = [];

  onSeqNoChange(data: any, index: any, newSeqNo: number) {
    const oldSeqNo = index + 1;
    for (let i = 0; i < this.dataList.length; i++) {
      if (oldSeqNo < newSeqNo) {
        if (
          this.SeqDataList[i].SEQ_NO > oldSeqNo &&
          this.SeqDataList[i].SEQ_NO < newSeqNo
        ) {
          this.SeqDataList[i].SEQ_NO--;
        }
        //
        if (this.SeqDataList[i].SEQ_NO == newSeqNo && i != index) {
          this.SeqDataList[i].SEQ_NO--;
        }
      } else {
        if (
          this.SeqDataList[i].SEQ_NO > newSeqNo &&
          this.SeqDataList[i].SEQ_NO < oldSeqNo
        ) {
          this.SeqDataList[i].SEQ_NO++;
        }
        //
        if (this.SeqDataList[i].SEQ_NO == newSeqNo && i != index) {
          this.SeqDataList[i].SEQ_NO++;
        }
      }
    }

    // Sort the list by SEQ_NO to maintain order
    this.SeqDataList.sort((a, b) => a.SEQ_NO - b.SEQ_NO);

    this.dataList = [...this.SeqDataList];
  }

  ResetData() {
    // this.loadingRecords = true;

    this.search(true);
  }


  UpdateProjectData(): void {
    this.projectData = this.dataList;
    this.loadingRecords = true;

    if (!this.projectData || this.projectData.length === 0) {
      this.message.error('Project list is empty', '');
      return;
    }

    const dataToSave = {
      data: this.projectData,
    };

    this.updateprojectrecords = true;
    this.api.updateSequenceData(dataToSave).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.message.success('Project data updated successfully', '');
          // this.ResetData();
          this.search(true);
        } else {
          this.message.error('Failed to update project data', '');
        }
        this.loadingRecords = false;
        this.updateprojectrecords = false;
      },
      (error) => {
        console.error('Error:', error);
        this.message.error('An error occurred while updating project data', '');
        this.loadingRecords = false;
        this.updateprojectrecords = false;
      }
    );
  }

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'SEQ_NO';
    const sortOrder = (currentSort && currentSort.value) || 'asc';

    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.search();
  }
}
